export var setUserIntent = function setUserIntent(api, tr) {
  var _api$userIntent;
  return api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.commands) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.setCurrentUserIntent('commenting')({
    tr: tr
  });
};
export var resetUserIntent = function resetUserIntent(api, tr) {
  var _api$userIntent2;
  return api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || (_api$userIntent2 = _api$userIntent2.commands) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.setCurrentUserIntent('default')({
    tr: tr
  });
};